<header></header>
<div class="post-login-2">
    <!-- <div class="post-login-2-col-1 h-100">
        <app-left-panel-prelogin activeTab="2" *ngIf="this.auth?.detailuser == undefined"></app-left-panel-prelogin>
        <left-panel activeTab="2" *ngIf="this.auth?.detailuser != undefined"></left-panel>
    </div> -->
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="2"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100 pt-70-pb-70-pr-40">
        <div class="onboarding-canvas h-100">
            <!-- sinnad -->
            <grid-row class="mt-30">
                <grid-col col="9">
                    <div class="font-400 font-size-20px line-h-25">
                        {{ "Enter your new card PIN" | translate }}
                    </div>
                    <div class="font-400 font-size-14px color-base-400 mt-10 line-h-20">
                        {{ "Please use a different PIN other than previously used PIN" | translate }}
                    </div>
                </grid-col>
            </grid-row>
            
            <grid-row class="mt-50 justify-content-center text-align-center">
                <grid-col col="12">
                    <!-- <form [formGroup]="otpform"> -->
                    <div class="form-group">
                        <ng-otp-input (onInputChange)="onnewOtpChange($event)" 
                            (keydown)="onnewKeyDown($event)" allowNumbersOnly='true'
                            [config]="{length:4,allowNumbersOnly:true,isPasswordInput:true}"></ng-otp-input>
                            <!-- formControlName="changeotp" -->
                        <!-- <ng-container item-content *ngFor="let validation of errorkey.validation_messages.otp1">
                                            <span class="color-red"
                                            *ngIf="otpform.controls.changeotp.hasError(validation.type) &&(otpform.controls.changeotp.touched)">
                                              {{ getMessage(validation.key,'otp1') }}
                                            </span>
                                          </ng-container> -->
                    </div>
                    <!-- </form> -->
                </grid-col>
            </grid-row>
            
            
            <grid-row class="justify-content-between align-item-center mt-50">
                <grid-col col="auto">
                    <div class="mt-15">
                        <button class="btn-back" (click)="back2sinnad()">
                            <i class="icon-back"></i>
                        </button>
                    </div>
                </grid-col>
                <grid-col col="9">
                    <button class="btn-dft" [disabled]="isnewValid()" (click)="next()">
                        {{ "Next" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>
<!-- <div class="pre-login">
    <div class="pre-login-col-1 h-100">
        <left-panel-onboarding></left-panel-onboarding>
    </div>
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas">
          

        </div>
    </div>
</div> -->